"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitorScheduleValues = exports.MonitorSchedule = void 0;
var MonitorSchedule;
(function (MonitorSchedule) {
    MonitorSchedule["EVERY_MINUTE"] = "EVERY_MINUTE";
    MonitorSchedule["EVERY_HOUR"] = "EVERY_HOUR";
})(MonitorSchedule = exports.MonitorSchedule || (exports.MonitorSchedule = {}));
exports.MonitorScheduleValues = Object.values(MonitorSchedule);
